export enum Components {
    CUSTOM_FILTER = "CustomFilter"
}

export enum ApplicantDetailsTable {
    STATUS_HISTORY = "status-history",
    ADJUDICATION_DOCS = "adjudication-docs",
    OUTGOING_TRANSMISSION = "outgoing-transmission",
    INCOMING_RESPONSE = "incoming-response",
    AUDIT_HISTORY = "audit-history",
    DOCUMENT_UPLOAD = "document-upload"
}

export enum RapbackMaintenance {
    RB_MAINTENANCE = "rapback-maintenance",
    RB_AUDIT_HISTORY = "rb-sub-audit-history"
}

export enum RapbackSummary {
    RAPBACK_SUMMARY = "rb-summary-audit-history"
}

export enum TransactionSummary {
    TRANSACTION_SUMMARY = "transaction-summary",
    REJECT_CODES = "reject-codes"
}

